<template>
  <aside>
    <div class="box">
      <span class="box-title">{{$t('hs.att-dashboard.contact')}}</span>
      <span class="company text-entry">HUBER+SUHNER AG</span>
      <span class="name text-entry">Marchi Paolo</span>
      <span class="additional-info text-entry">{{$t('hs.att-dashboard.support-initial-contact')}}<a href="mailto:paolo.marchi@hubersuhner.com"> {{$t('hs.att-dashboard.email')}}</a></span>
      <span class="phone text-entry"><font-awesome-icon style="color: #888;" :transform="{ rotate: 90 }" icon="phone" /><a href="tel:+41 44 952 2796">+41 44 952 2796</a></span>
    </div>
    <div class="box" v-if="infoResponse">
      <h2 class="box-title">{{$t('hs.att-dashboard.downloads')}}</h2>
      <ul class="list-with-arrows">
        <li class="document-entry">
          <a :href="pdfUri" download>{{$t('hs.att-dashboard.certificate-as-PDF')}}</a>
        </li>
        <li class="document-entry">
          <a :href="s2pUri" download>{{$t('hs.att-dashboard.certificate-as-s2p')}}</a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
  export default {
    name: 'Sidenav',
    data () {
      return {

      }
    },
    props: {
      infoResponse: {
        type: Object
      },
      error: {
        type: Object
      }
    },
    computed: {
      pdfUri () {
        return this.infoResponse.link('pdf').prop('href')
      },
      s2pUri () {
        return this.infoResponse.link('s2p').prop('href')
      }
    }
  }
</script>

<style lang="scss" scoped>
  aside {
    margin-top: -1rem;
    margin-bottom: -1rem;
    display: flex;
    flex-direction: column;
  }

  .box {
    display: flex;
    flex-direction: column;
    background-color: $light-gray;
    padding: 2rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .box-title {
    color: $blue;
    font-weight: bold;
    font-size: 1.6rem;
  }

  .name {
    font-weight: bold;
    margin-top: 0.5rem;
  }

  .document-entry {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
  }

  .fa-phone {
    margin-right: 1rem;
  }

  .text-entry {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
</style>
